import axios from 'axios';
import * as caseConverter from 'change-object-case';

import { ROUTES } from '#/routes';
import { getSessionStorageItem, removeSessionStorageItem } from '#/utils';
import { ACCESS_TOKEN } from '#/utils/constants';
import { getLocalStorageItem, removeLocalStorageItem } from '#/utils/localStorage';

const options = { recursive: true, arrayRecursive: true };

export function useSetupAxios() {
    axios.interceptors.request.use(config => {
        const accessToken = getLocalStorageItem(ACCESS_TOKEN) || getSessionStorageItem(ACCESS_TOKEN);

        if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;

        if (!(config?.data instanceof FormData)) {
            const caseConvertedData = caseConverter.snakeKeys(config?.data, options);
            config.data = caseConvertedData;
        }

        const caseConvertedData = caseConverter.snakeKeys(config.params);
        config.params = caseConvertedData;

        return config;
    });

    axios.interceptors.response.use(
        response => {
            const caseConvertedData = caseConverter.camelKeys(response?.data, options);
            response.data = caseConvertedData;
            return response;
        },
        error => {
            if (error.response && error.response.status === 401) {
                if (getLocalStorageItem(ACCESS_TOKEN) || getSessionStorageItem(ACCESS_TOKEN)) {
                    removeLocalStorageItem(ACCESS_TOKEN);
                    removeSessionStorageItem(ACCESS_TOKEN);
                    window.location.replace(ROUTES.UNAUTHORIZE);
                }
            }

            return Promise.reject(error);
        }
    );

    return;
}
